import getNextMonthDate from '@anm/helpers/date/getNextMonthDate';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import noop from '@anm/helpers/noop';
import { useCallback, FC } from 'react';

import DatesTable from '../DatesTable';
import { CalendarButton, DatePickerContentWrapper, NextButton, PrevButton, TablesWrapper } from '../Wrapper';
import { useMonthSwitcher } from '../hooks';
import { DatePickerProps } from '../types';

const DatePickerContent: FC<DatePickerProps> = ({
  isRangeDate,
  selectedDates,
  isOneCalendar,
  disableDates,
  onDatePick,
  onDateApply,
  onClickCancel
}) => {
  const [currentViewDate, handleNextMonthClick, handlePrevMonthClick, handleStopPropagation] = useMonthSwitcher(
    selectedDates
  );

  const handleDateApply = useCallback(() => {
    onDateApply(selectedDates);
  }, [onDateApply, selectedDates]);

  const handleWrapperClick = isMobileOrIPad() ? noop : handleStopPropagation;

  const tableProps = {
    selectedDates,
    disableDates,
    isRangeDate
  };

  return (
    <DatePickerContentWrapper onClick={handleWrapperClick}>
      <TablesWrapper onClick={handleStopPropagation}>
        <DatesTable
          onDateChange={onDatePick}
          {...{
            currentViewDate,
            ...tableProps
          }}
        />
        {!isOneCalendar && (
          <DatesTable {...tableProps} onDateChange={onDatePick} currentViewDate={getNextMonthDate(currentViewDate)} />
        )}
        <NextButton src="images/picker_left_arrow.svg" onClick={handleNextMonthClick} alt="next month button" />
        <PrevButton src="images/picker_left_arrow.svg" onClick={handlePrevMonthClick} alt="previous month button" />
      </TablesWrapper>
      <CalendarButton onClick={onClickCancel} variant="silver" size="medium">
        Cancel
      </CalendarButton>
      <CalendarButton size="medium" variant="white-blue-border-share" onClick={handleDateApply}>
        Apply
      </CalendarButton>
    </DatePickerContentWrapper>
  );
};

export default DatePickerContent;
